export default function getPosition(end) {
  console.log(end);
  //el 标签  speed 滚动速率 此处是50px 值越大滚动的越快
  let speed = 250;
  let scrollTop =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset; //获取滚动条的高度(兼容三种浏览器版本)
  let top = end; //需要滚动的位置
  let currentTop = scrollTop; //默认滚动位置为当前滚动条位置，若改为0，则每次都会从顶部滚动到指定位置
  let requestId;
  //采用requestAnimationFrame，平滑动画
  function step() {
    //判断让滚动条向上滚还是向下滚
    if (scrollTop < top) {
      if (currentTop <= top) {
        //   window.scrollTo(x,y) y为上下滚动位置
        window.scrollTo(0, currentTop);
        requestId = window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(requestId);
      }
      //向下滚动
      currentTop += speed;
    } else {
      if (top <= currentTop) {
        //注：此处 - speed 是解决居中时存在的问题，可自行设置或去掉
        window.scrollTo(0, currentTop - speed);
        requestId = window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(requestId);
      }
      //向上滚动
      currentTop -= speed;
    }
  }
  window.requestAnimationFrame(step);
}
